import React from "react";
import '../css/Modal_Remerciement.css';


const Modal_Remerciement = ({ show, onClose }) => {
  if (!show) return null;

  return (
    <div className="modal-remerciements-backdrop">
      <div
        className="modal-remerciements-content"
        style={{width:'300px',height:'240px' , textAlign: "center" }}
      >
        <div className="modal-header">
          <h2>Merci pour votre contribution !</h2>
        </div>
        <div>
          <p>
            Vos modifications ont bien été enregistrées. Elles seront vérifiées
            par notre équipe avant d'être publiées.
          </p>
          
          <button className="pop-up_modif_button" onClick={onClose}>
            Fermer
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal_Remerciement;
